import React from "react";

const MapMarker = props => {
  const thisAddress = `${props.address} ${props.city}, ${props.state} ${
      props.zipcode
      }`;
  const link = "https://maps.google.com/?q=";
    let thisClass;

    const distPin = props.dist ? 'distributor' : '';

  if (props.target === props.text.toString()) {
    thisClass = props.class;
  } else {
    thisClass = "dealer-address-map no-show";
  }
    return (
        <div className="marker-container">
            <button className={`dealer-map-marker ${distPin}`} onClick={props.onChange}>
        {props.text}
      </button>
    </div>
  );
};

export default MapMarker;


///<div className={thisClass}>
//    <h3 className="marker-name">{props.name}</h3>
//    <div className="map-address">
//        <a
//            className="address-link"
//            href={`${link}${thisAddress}`}
//            target="_blank"
//        >
//            {thisAddress}
//        </a>
//    </div>
//</div>